const merchantSizeOptions = [
  { label: 'Small', value: 'small' },
  { label: 'Large', value: 'large' },
];

const collectionChannelOptions = [
  { label: 'Online', value: 'online' },
  { label: 'Offline', value: 'offline' },
];

const merchantDomainOptions = [
  {
    value: 'Retail and Ecommerce - Products',
    label: "Retail and Ecommerce - Products",
  },
  {
    value: 'Retail and Ecommerce - Services',
    label: "Retail and Ecommerce - Services",
  },
  {
    value: 'Travel and Tourism',
    label: "Travel and Tourism",
  },
  {
    value: 'BFSI/Fintech',
    label: "BFSI/Fintech",
  },
  {
    value: 'food & Beverages',
    label: "food & Beverages",
  },
  {
    value: 'Healthcare',
    label: "Healthcare",
  },
  {
    value: 'Automotive',
    label: "Automotive",
  },
  {
    value: 'Professional Services',
    label: "Professional Services",
  },
  {
    value: 'Real Estate',
    label: "Real Estate"
  },
  {
    value: 'Logistics and warehousing',
    label: "Logistics and warehousing"
  },
  {
    value: 'Society/Clubs/NGO',
    label: "Society/Clubs/NGO"
  },
  {
    value: 'Agriculture Services',
    label: "Agriculture Services"
  },
  {
    value: 'Government',
    label: "Government"
  },
  {
    value: 'Education',
    label: "Education"
  },
  {
    value: 'Communications and connectivity',
    label: "Communications and connectivity"
  },
  {
    value: 'Utility Payments',
    label: "Utility Payments"
  },
  {
    value: 'Not Classified above',
    label: "Not Classified above"
  }
]


export const businessTypeCode = [
  { value: "3", label: "3 - Companies registered under act" },
  { value: "4", label: "4 - Govt/ Govt Undertakings" },
  { value: "1", label: "1 - Individual- HUF" },
  { value: "42", label: "42 - Individuals / Professionals" },
  { value: "45", label: "45 - LLPs" },
  { value: "2", label: "2 - Partnership" },
  { value: "41", label: "41 - Proprietor" },
  { value: "44", label: "44 - Regd Trusts" },
];


// const merchantDomainOptions = [
//     {
//       value: 'Automotive - Dealers',
//       label: 'Automotive - Dealers',
//     },
//     {
//       value: 'Automotive - Other Services',
//       label: 'Automotive - Other Services',
//     },
//     {
//       value: 'Books & stationary',
//       label: 'Books & stationary',
//     },
//     {
//       value: 'Cable and Internet services',
//       label: 'Cable and Internet services',
//     },
//     {
//       value: 'Computer Equipments',
//       label: 'Computer Equipments',
//     },
//     {
//       value: 'Construction Materials',
//       label: 'Construction Materials',
//     },
//     {
//       value: 'Consulting',
//       label: 'Consulting',
//     },
//     {
//       value: 'Ecom & Retail stores',
//       label: 'Ecom & Retail stores',
//     },
//     {
//       value: 'EDUCATION',
//       label: 'EDUCATION',
//     },
//     {
//       value: 'Electronic Stores',
//       label: 'Electronic Stores',
//     },
//     {
//       value: 'F&B',
//       label: 'F&B',
//     },
//     {
//       value: 'Gaming',
//       label: 'Gaming',
//     },
//     {
//       value: 'General Merchandise',
//       label: 'General Merchandise',
//     },
//     {
//       value: 'Gift & jewelery',
//       label: 'Gift & jewelery',
//     },
//     {
//       value: 'Government Services',
//       label: 'Government Services',
//     },
//     {
//       value: 'Grocery and Supermarkets',
//       label: 'Grocery and Supermarkets',
//     },
//   ];

const master_data = {
  "Retail and Ecommerce - Products": [
      "Apparels and Accessories",
      "Marketplace - all types of products",
      "Shoes",
      "Furniture and Home furnishing",
      "Household appliances",
      "Consumer Electronics - Including gaming consoles",
      "Construction Material",
      "Industrial Supplies",
      "Hardware stores",
      "Musical Instruments",
      "Used and 2nd Hand merchandise",
      "Bicycle shops",
      "Book Store",
      "Stationery Store / Office Supplies",
      "Precious Jewelry / Watches",
      "Toy Shops",
      "Gift Items / Souvenir Shops",
      "Bags and Luggage",
      "Cosmetic Products",
      "Florist",
      "Pet Food and Supplies",
      "Department Store",
      "Ayurvedic products / food supplements",
      "Not Classified above"
  ],
  "Retail and Ecommerce - Services": [
      "IT Services - website/app development",
      "Software store",
      "Digital Media - Books/Music/Artwork/Movies/Digital Games (PC/Console)",
      "Online Gaming - Poker/Rummy/Teen Patti/Fantasy Sports/Ludo",
      "Online Gaming - Esports",
      "Streaming Services/OTT Platforms",
      "Advertising Services",
      "Employment Agencies",
      "Dating/Escort Services",
      "Betting/Lottery/Casino",
      "Cleaning / Janitorial Services",
      "Consultants - Management / Marketing/PR",
      "Automobile Rental ",
      "Vendor Payment - B2B Payments",
      "Not Classified above"
  ],
  "Travel and Tourism": [
      "Travel Agencies and tour operators including package tours",
      "Hotel/Resort/Lodge/BnB",
      "Commuter passenger transportation including ferries",
      "Passenger railways",
      "Taxicab and Limousine including ride share",
      "Bus Lines",
      "Steamship and cruiselines",
      "Airline Company/Operator",
      "Tolls and Bridge fees"
  ],
  "BFSI/Fintech": [
      "Bank or NBFC - Loan repayments and disbursements",
      "PPI Issuers/Wallets",
      "Forex dealer",
      "Insurance companies",
      "Mutual funds companies/Broker/Dealer",
      "Stocks and Securities broker/dealer",
      "Digi Gold",
      "Money Transfer"
  ],
  "food & Beverages": [
      "Restaurant/Café",
      "Catering Services",
      "Grocery Store/Supermarket",
      "Dairy products",
      "Cany/Nuts/confectionery",
      "Bakeries",
      "Food items not classified above"
  ],
  "Healthcare": [
      "Hospitals",
      "Medical and Dental Labs",
      "Ambulance Service",
      "Nursing/Home Healthcare/Personal Care facilities",
      "Doctors and Physicians",
      "Opticians/Optical Goods/Eyeglasses",
      "Drug Store and pharmacies"
  ],
  "Automotive": [
      "Car dealers (new cars)",
      "Used Car dealers",
      "Automotive parts and accessories",
      "Motorcycle shops and dealers including riding accessories",
      "Automobile service stations",
      "EV Charging"
  ],
  "Professional Services": [
      "Tax Preparation services",
      "Accounting/Auditing/Book keeping services",
      "Legal services and Attorneys",
      "Market Research reports",
      "Graphic Designers"
  ],
  "Real Estate": [
      "Contractors/Builders - Residential and Commercial",
      "Rental Payments/Real Estate brokers and managers",
      "Electrical Contractors",
      "Carpentry Contractors"
  ],
  "Logistics and warehousing": [
      "Movers and Packers/Local Delivery services",
      "Courier Services",
      "Public warehousing and Storage"
  ],
  "Society/Clubs/NGO": [
      "Donations - Social",
      "Donations - Religious",
      "Membership Fee / Event Management"
  ],
  "Agriculture Services": [
      "Agriculture co-operatives/Farm Management/Farming operations",
      "Landscaping/Horticuture/Gardening",
      "Nursery/Seeds/Fertilizers/Garden Supplies"
  ],
  "Government": [
      "Tax payments",
      "Post office",
      "Other Services"
  ],
  "Education": [
      "College/University/Junior College",
      "Schools - Elementary/Secondary/Higher secondary",
      "Others - Coaching classes/Tuition classes/Edtech/Not classified above"
  ],
  "Communications and connectivity": [
      "Cable Operators and ISP",
      "Telecom"
  ],
  "Utility Payments": [
      "BBPS Agents",
      "Utility provider - Electricity board/Water Dept/Sanitation dept etc"
  ],
  "Not Classified above": [
      "Please explain business model and product/service offering"
  ]
}


export { merchantDomainOptions, merchantSizeOptions, collectionChannelOptions, master_data }